import API from "./axios";

/** Ledger hub helpers — pending bill/entry/slip counts per party. */
const ledgerHubApi = {
  pendingCounts: () => API.get("/ledger-hub/pending-counts"),
  typeTotals: () => API.get("/ledger-hub/type-totals"),
};

export default ledgerHubApi;